// Fixed storefront header: hides while scrolling down, returns on scroll up,
// and stays transparent over the homepage banner until the page scrolls.
class SHeader extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.lastY = Math.max(window.scrollY, 0);
    this.ticking = false;
    this.transparentAtTop = this.hasAttribute('transparent-at-top');

    window.addEventListener('scroll', () => this.#schedule(), { passive: true, signal });
    window.addEventListener('resize', () => this.#schedule(), { passive: true, signal });
    this.addEventListener('focusin', () => { this.dataset.hidden = 'false'; }, { signal });
    this.#update();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  #schedule() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => this.#update());
  }

  #update() {
    this.ticking = false;
    const y = Math.max(window.scrollY, 0);
    const delta = y - this.lastY;
    const threshold = this.offsetHeight;

    if (y <= threshold || this.matches(':focus-within')) {
      this.dataset.hidden = 'false';
    } else if (delta > 6) {
      this.dataset.hidden = 'true';
    } else if (delta < -6) {
      this.dataset.hidden = 'false';
    }

    this.dataset.transparent = String(this.transparentAtTop && y < 8);
    this.lastY = y;
  }
}

customElements.define('s-header', SHeader);
